export const lightStrongAdditional = "#33adff";
